import React, { useState, useEffect, useCallback } from 'react';
import { makeStyles, ThemeProvider as CoreThemeProvider, createMuiTheme as createCoreTheme } from '@material-ui/core/styles';
import { ThemeProvider as MuiThemeProvider, createTheme as createMuiTheme } from '@mui/material/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Tooltip } from '@mui/material';
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // Ícone para "finalizar"
import IconButton from '@mui/material/IconButton';
import ForwardIcon from '@mui/icons-material/Forward';
import MapIcon from '@mui/icons-material/Map';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ListAltIcon from '@mui/icons-material/ListAlt';
import EventIcon from '@mui/icons-material/Event';
import SettingsIcon from '@mui/icons-material/Settings';
import DeleteIcon from '@mui/icons-material/Delete';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import TextField from '@material-ui/core/TextField';
import RefreshIcon from '@mui/icons-material/Refresh';
import Cookies from 'js-cookie';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import AppBar from '@mui/material/AppBar';
import Box from '@material-ui/core/Box';
import { useHistory } from "react-router-dom";
import moment from 'moment';
import { useParams } from "react-router-dom";
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';
import { styled } from '@material-ui/styles';
import { Card, CardContent } from '@mui/material';
import { Link } from 'react-router-dom';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CheckIcon from '@mui/icons-material/Check';
import { useDropzone } from 'react-dropzone';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CancelIcon from '@mui/icons-material/Cancel';
import Popover from '@mui/material/Popover';
import InventoryIcon from "@mui/icons-material/Inventory"; // ícone de caixa / estoque
import EditIcon from '@mui/icons-material/Edit';

import api from '../../../../../services/api';
import SNARonda from '../../../../../pages/painelAdmin/AreaGestao/ModuloOperacional/RondaVirtual/snaRonda';

import CadastrarProcedimentoAvulso from './cadastrarProcedimentoAvulso.js';
import CabecalhoInformacoes from './CabecalhoInformacoes.js';
import CabecalhoInformacoes2 from './CabecalhoInformacoes2.js';
import RepassarProcedimento from './repassarProcedimento.js';
import GerenciarReserva from './gerenciarReserva.js';

import { returnDescricaoInsumo } from '../../../../../utils/insumoHelpers';

import MenuRecursosAdministrativos from '../components/menu';
import NavegadorGestao from "../../../../../components/NavBarGestao";
import {
    DataGrid,  
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';
import { AddToQueueOutlined, LaptopWindows } from '@material-ui/icons';

import GerenciarTratamentoEmCampo from './gerenciarTratamentoEmCampo';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'; // Ícone apropriado
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';

import ComponentAgendamento from '../../../../../pages/painelAdmin/AreaGestao/ModuloOperacional/Agendamentos/componentAgendamento.js';



const ColorButtonBlue = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'blue',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'blue',
        color: 'whit',
        borderColor: 'red',
    },
}));


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& .cabecalho_transparente': {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            color: 'rgba(0, 0, 0, 0)',
        },
        '& .cabecalho_azul': {
            backgroundColor: 'rgba(0, 0, 255, 1)',
            color: 'white',
        },
        '& .cabecalho_verde': {
            backgroundColor: 'rgba(0, 100, 0, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_claro': {
            backgroundColor: 'rgba(107,142,35, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_claro': {
            backgroundColor: 'rgba(184,134,11, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_cyan': {
            backgroundColor: 'rgba(0,139,139, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_dark_sea': {
            backgroundColor: 'rgba(60,179,113, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_escuro': {
            backgroundColor: 'rgba(139,69,19, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_chocolate': {
            backgroundColor: 'rgba(210,105,30, 1)',
            color: 'white',
        },
        '& .cabecalho_darkslate': {
            backgroundColor: 'rgba(47,79,79, 1)',
            color: 'white',
        },
        '& .super-app.negative': {
            backgroundColor: 'rgba(157, 255, 118, 0.49)',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.positive': {
            backgroundColor: '#d47483',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.neutro': {
            backgroundColor: '#363636',
            color: 'white',
            fontWeight: '600',
        },
    },

    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
}));

const ColorButtonRed = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'red',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'red',
        color: 'whit',
        borderColor: 'blue',
    },
}));



const ColorButtonGreen = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'green',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'green',
        color: 'whit',
        borderColor: 'blue',
    },
}));




const dropzoneStyles = {
    border: '4px dashed #000000',
    borderRadius: '4px',
    padding: '2px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '2px 0',
};



export default function RequerimentoInsumos({ flag = 0, ordemServicoIn }) {

    const [darkMode, setDarkMode] = useState(() => {
        const saved = Cookies.get('darkMode') || Cookies.get('tema');
        return saved === 'true' || saved === 'dark';
    });

    useEffect(() => {
        const checkDarkMode = () => {
            const saved = Cookies.get('darkMode') || Cookies.get('tema');
            setDarkMode(saved === 'true' || saved === 'dark');
        };

        window.addEventListener('darkModeChanged', checkDarkMode);
        window.addEventListener('temaChanged', checkDarkMode);
        window.addEventListener('focus', checkDarkMode);

        return () => {
            window.removeEventListener('darkModeChanged', checkDarkMode);
            window.removeEventListener('temaChanged', checkDarkMode);
            window.removeEventListener('focus', checkDarkMode);
        };
    }, []);

    const themeV5 = React.useMemo(() => createMuiTheme({
        palette: {
            mode: darkMode ? 'dark' : 'light',
            background: {
                default: darkMode ? '#121212' : '#ffffff',
                paper: darkMode ? '#1e1e1e' : '#ffffff',
            }
        },
    }), [darkMode]);

    const themeV4 = React.useMemo(() => createCoreTheme({
        palette: {
            type: darkMode ? 'dark' : 'light',
            background: {
                default: darkMode ? '#121212' : '#ffffff',
                paper: darkMode ? '#1e1e1e' : '#ffffff',
            },
            text: {
                primary: darkMode ? '#ffffff' : '#000000',
                secondary: darkMode ? '#aaaaaa' : '#666666',
            }
        },
        overrides: {
            MuiTextField: {
                root: darkMode ? {
                    '& label.Mui-focused': { color: 'white' },
                    '& label': { color: 'white' },
                    '& .MuiInput-underline:before': { borderBottomColor: 'white' },
                    '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: 'white' },
                    '& .MuiInput-underline:after': { borderBottomColor: 'white' },
                    '& .MuiInputBase-input': { color: 'white' },
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: 'white' },
                        '&:hover fieldset': { borderColor: 'white' },
                        '&.Mui-focused fieldset': { borderColor: 'white' },
                    },
                } : {},
            },
            MuiFormLabel: {
                root: darkMode ? {
                    color: 'white',
                    '&$focused': {
                        color: 'white'
                    }
                } : {}
            },
            MuiInputBase: {
                input: darkMode ? {
                    color: 'white',
                } : {}
            },
            MuiAutocomplete: {
                root: darkMode ? {
                    '& .MuiInputLabel-root': { color: 'white' },
                    '& .MuiInput-underline:before': { borderBottomColor: 'white' },
                } : {},
                popupIndicator: darkMode ? {
                    color: 'white'
                } : {},
                clearIndicator: darkMode ? {
                    color: 'white'
                } : {},
                paper: darkMode ? {
                    backgroundColor: '#1e1e1e',
                    color: 'white'
                } : {}
            }
        },
    }), [darkMode]);

    const [openGerenciarReserva, setOpenGerenciarReserva] = useState(false);


    const [reservaGerenciada, setReservaGerenciada] = useState(null);

    function handleGerenciarReserva(reserva) {
        setReservaGerenciada(reserva);
        setOpenGerenciarReserva(true);
    }


    function handleCloseGerenciarReserva() {
        setOpenGerenciarReserva(false);
        setReservaGerenciada(false);
        recarregarItens();
    }

    const [informaDialog, setInformaDialog] = useState(true); // abre assim que entra na rota
    const [quantidadeDoEstoque, setQuantidadeDoEstoque] = useState(0);
    const [quantidadeNoEstoque, setQuantidadeNoEstoque] = useState(0);

    const [temEstoque, setTemEstoque] = useState(false);
    const regra = Cookies.get("regra") || "";


    const [ordemServico, setOrdemServico] = useState(ordemServicoIn);

    const [mostrarDialog, setMostrarDialog] = useState(false);


    function handleSetInsumoSelecionado(insumo_) {
        try {
            const insumo = insumo_.insumo;
        } catch (_err) {
            setInsumoSelecionado(null);

            return;
        }

        try {
            if (Array.isArray(insumo_.itens_estoque) && insumo_.itens_estoque.length > 0) {
                const itensDisponiveis = insumo_.itens_estoque.filter(item => item.status_item === 0);

                if (itensDisponiveis.length > 0) {
                    setTemEstoque(true);
                    setQuantidadeNoEstoque(itensDisponiveis.length);
                } else {
                    setTemEstoque(false);
                    setQuantidadeNoEstoque(0);
                }
            } else {
                setTemEstoque(false);
                setQuantidadeNoEstoque(0);
            }
        } catch (_err) {
            setTemEstoque(false);
            setQuantidadeNoEstoque(0);
            console.error("Erro ao verificar itens de estoque:", _err);
            setInsumoSelecionado(null);

            return;
        }

        setInsumoSelecionado(insumo_);
    }

    function handleSetQuantidadeDoEstoque(valor) {
        const valorNumerico = parseFloat(valor);

        if (valor === "") {
            setQuantidadeDoEstoque("");
            return;
        }

        if (!isNaN(valorNumerico) && valorNumerico <= quantidade && valorNumerico <= quantidadeNoEstoque) {
            setQuantidadeDoEstoque(valor);
        } else {
            // alert(`A quantidade informada deve ser no máximo ${Math.min(quantidade, quantidadeNoEstoque)}.`);
        }
    }



    const classes = useStyles();
    const history = useHistory();

    const [loading, setLoading] = useState(true);

    const [limiar, setLimiar] = useState(900);

    const [larguraOriginal, setLarguraOriginal] = useState(0);







    useEffect(() => {
        // Função que verifica se o modal deve aparecer
        const checarCondicoes = () => {
            if (!ordemServico) return null; // nada a mostrar
            if (ordemServico.solicitacao.id_solicitacao !== 7) return null; // só bloquear para solicitacao 7

            const semItens =
                !ordemServico.itens_pre_requerimento ||
                ordemServico.itens_pre_requerimento.length < 1;
            const finalizarPend =
                ordemServico.itens_pre_requerimento &&
                ordemServico.itens_pre_requerimento.length >= 1 &&
                ordemServico.finalizar_requerimento_itens === 0;

            if (semItens) return "adicionar"; // mostrar mensagem de adicionar itens
            if (finalizarPend) return "finalizar"; // mostrar mensagem de finalizar
            return null; // não precisa mostrar
        };

        // Evento beforeunload (fechar/recarregar aba)
        const handleBeforeUnload = (event) => {
            const acao = checarCondicoes();
            if (acao) {
                event.preventDefault();
                event.returnValue = ""; // bloqueia o fechamento temporariamente
                setTimeout(() => setMostrarDialog(true), 200);
            }
        };

        // Evento mousemove (aproximação do topo da aba)
        const handleMouseMove = (e) => {
            const acao = checarCondicoes();
            if (e.clientY < 50 && acao) {
                setMostrarDialog(true);
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);
        document.addEventListener("mousemove", handleMouseMove);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
            document.removeEventListener("mousemove", handleMouseMove);
        };
    }, [ordemServico]);


    function checkDimenssoes() {
        var largura = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;

        setLarguraOriginal(largura);


    }

    window.addEventListener('resize', function (event) {
        checkDimenssoes();
    });



    useEffect(() => {

        //alert("Regras: " + regra);

        checkDimenssoes();
        listarInformacoes();

    }, []);



    const [descricao, setDescricao] = useState('');
    const [solicitacaoSelecionada, setSolicitacaoSelecionada] = useState(null);


    const [observacoesItem, setObservacoesItem] = useState('');
    const [descricaoNovoInsumo, setDescricaoNovoInsumo] = useState('');


    const [usuarioSelecionadoTratarRemoto, setUsuarioSelecionadoTratarRemoto] = useState(null);
    const [usuarioSelecionadoTratarEmCampo, setUsuarioSelecionadoTratarEmCampo] = useState(null);

    function returnDescricaoInsumo2(insumo_) {

        let insumo = insumo_.insumo;
        let textoComQuebraDeLinha = "Descrição Principal: " + insumo.descricao;

        if (insumo.variacoes && insumo.variacoes.length > 0) {
            textoComQuebraDeLinha += insumo.variacoes

                .map((variacao, index) => (
                    `<br />*Variação-> Fornecedor: ${variacao.nome_amigavel_fornecedor} Variação: ${variacao.descricao}${index !== insumo.variacoes.length - 1 ? '\n' : ''}`
                )).join('');
        }

        var texto =

            //"<br />Marca/Modelo: " + insumo.marca + "/" + insumo.modelo +
            // "<br />Código Fornecedor: " + insumo.codigo_fornecedor +
            //"<br />Tipo: " + insumo.tipo +
            //"<br />Categoria: " + insumo.categoria +
            textoComQuebraDeLinha + "<br />Estoque: " + (Array.isArray(insumo_.itens_estoque) ? insumo_.itens_estoque.length : 0) + " unidades";
        return texto;
    }


    function returnDescricaoInsumo3(insumo_) {

        let insumo = insumo_.insumo;
        let textoComQuebraDeLinha = "Descrição Principal: " + insumo.descricao;

        if (insumo.variacoes && insumo.variacoes.length > 0) {
            textoComQuebraDeLinha += insumo.variacoes

                .map((variacao, index) => (
                    `<br />*Variação-> Fornecedor: ${variacao.nome_amigavel_fornecedor} Variação: ${variacao.descricao}${index !== insumo.variacoes.length - 1 ? '\n' : ''}`
                )).join('');
        }




        if (insumo.cotacoes && insumo.cotacoes.length > 0) {
            const cotacoesOrdenadas = [...insumo.cotacoes].sort((a, b) => new Date(a.data) - new Date(b.data));

            // Formata número para moeda brasileira
            const formatarValor = (valor) =>
                new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);

            // Formata data para pt-BR
            const formatarData = (data) =>
                new Date(data).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });

            // 👉 Mantém todas para cálculo, mas pega só as 3 últimas para exibir
            const ultimasTres = cotacoesOrdenadas.slice(-3);

            // Constrói o texto com as 3 últimas cotações formatadas
            textoComQuebraDeLinha += ultimasTres
                .map((cotacao) => {
                    return `<br />*Cotação -> ${formatarValor(cotacao.valor_unitario)} em ${formatarData(cotacao.data)}`;
                })
                .join('');
            const soma = cotacoesOrdenadas.reduce((acc, c) => acc + c.valor_unitario, 0);
            const media = soma / cotacoesOrdenadas.length;
            textoComQuebraDeLinha += `<br />Valor médio: ${formatarValor(media)}`;

            // Última cotação (maior data após ordenação)
            const ultimaCotacao = cotacoesOrdenadas[cotacoesOrdenadas.length - 1];
            textoComQuebraDeLinha += `<br />Última Cotação: ${formatarValor(ultimaCotacao.valor_unitario)} em ${formatarData(ultimaCotacao.data)}`;
        } else {
            textoComQuebraDeLinha += `<br />Sem cotações`;
        }





        var quantidadeDisponivel = 0;

        if (Array.isArray(insumo_.itens_estoque)) {
            quantidadeDisponivel = insumo_.itens_estoque.filter(item => item.status_item === 0).length;
        }

        var texto = textoComQuebraDeLinha + "<br />Estoque: " + quantidadeDisponivel + " unidades";
        return texto;
    }



    function returnDescricaoInsumoSimplificada(insumo) {
        try {
            // Tenta acessar diretamente insumo.descricao
            if (insumo?.descricao) {
                return "Descrição: " + insumo.descricao;
            }

            // Se não houver, tenta insumo.insumo.descricao
            if (insumo?.insumo?.descricao) {
                return "Descrição: " + insumo.insumo.descricao;
            }

            // Se nenhum dos dois funcionar
            return "Descrição: não disponível";
        } catch (error) {
            return "Descrição: erro ao obter";
        }
    }


    const [insumos, setInsumos] = useState([]);
    const [insumoSelecionado, setInsumoSelecionado] = useState(null);
    const [quantidade, setQuantidade] = useState(0);

    function handleSetInsumo(insumo) {
        setInsumoSelecionado(insumo);
    }


    async function recarregarItens() {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }


            await api.get("/v1/protected/ordemservico/listarporid/" + ordemServico.id_ordem_servico, {
                headers: headers
            }).then(function (response) {

                try {
                    const sortedItensPreRequerimento = response.data.itens_pre_requerimento.sort((a, b) => a.id_item_na_lista - b.id_item_na_lista);

                    // Atualiza o estado com a ordem de serviço e os itens ordenados
                    setOrdemServico({ ...response.data, itens_pre_requerimento: sortedItensPreRequerimento });
                } catch (_err) {
                    console.log("Erro ao reordernar: " + _err)
                }


                setLoading(false);



            });



        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }
    }

    async function listarInformacoes() {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }



            try {
                const sortedItensPreRequerimento = ordemServico.itens_pre_requerimento.sort((a, b) => a.id_item_na_lista - b.id_item_na_lista);

                // Atualiza o estado com a ordem de serviço e os itens ordenados
                setOrdemServico({ ...ordemServico, itens_pre_requerimento: sortedItensPreRequerimento });
            } catch (_err) {

            }

            {/*
            await api.get("v1/protected/almoxarifado/estoque/listarporinsumosrapido", {
                headers: headers
            }).then(function (response) {
                setInsumos(response.data)

 

                setLoading(false);


            }); */}

            setLoading(false);




        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }

    }








    const [value, setValue] = React.useState(0);



    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }















    async function adicionarItem() {

        const headers = {
            'Authorization': 'Bearer ' + Cookies.get("token")
        }
        if (!insumoSelecionado) {

            if (regra.includes("ADMIN_INSUMOS_NOVO_INSUMO")) {
                if (descricaoNovoInsumo.length <= 0) {
                    alert("Selecione o Insumo ou Insira a descrição para um novo Insumo!");
                    return;
                } else {
                    try {
                        const response = await api.get(
                            "/v1/protected/almoxarifado/insumos/semelhantes",
                            {
                                headers: headers,
                                params: { descricao: descricaoNovoInsumo }
                            }
                        );

                        const semelhantes = response.data;

                        if (semelhantes && semelhantes.length > 0) {
                            // Monta mensagem com as descrições semelhantes
                            const mensagens = semelhantes.map(i => i.descricao).join(", ");
                            const mensagem = "⚠️ Já existem insumos semelhantes: " + mensagens + "\n\nDeseja seguir com o cadastro mesmo assim?";

                            const confirmar = window.confirm(mensagem);
                            if (!confirmar) {
                                return; // usuário cancelou, impede adicionar
                            }
                            // se clicou em OK, segue o cadastro normalmente
                        }

                    } catch (err) {
                        console.error("Erro ao buscar semelhantes:", err);
                        alert("Erro ao verificar insumos semelhantes. Tente novamente mais tarde.");
                        return;
                    }
                }

            } else {
                alert("Selecione o Insumo");
                return;
            }


        } else {
            // alert(JSON.stringify(insumoSelecionado));
        }

        if (!quantidade || parseInt(quantidade) <= 0) {
            alert("Informe a quantidade!");
            return;
        }

        try {

            console.log("cadastrar chamado");
            const cadastro = {
                observacoes: observacoesItem,
                quantidade: parseInt(quantidade),
                insumo: insumoSelecionado !== null ? { id_insumo: insumoSelecionado.insumo.id_insumo } : null,
                descricao: descricaoNovoInsumo,

            }

            if (insumoSelecionado) {
                cadastro.id_insumo = insumoSelecionado.insumo.id_insumo;
            }




            const id_usuario_logado = parseInt(Cookies.get("id_usuario"));

            if (temEstoque) {
                cadastro.quantidade_reservada = quantidadeDoEstoque;
                cadastro.quantidade_a_comprar = quantidade - quantidadeDoEstoque;
            } else {
                cadastro.quantidade_reservada = 0;
                cadastro.quantidade_a_comprar = quantidade;
            }

            const response = await api.put("/v1/protected/ordemservico/editarrequerimento/" + ordemServico.id_ordem_servico + "/" + id_usuario_logado + "/inseriritem", cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                recarregarItens();

                setInsumoSelecionado(null);
                setQuantidade(0);
                setObservacoesItem('');
                setDescricao('');
                setTemEstoque(false);
                setQuantidadeNoEstoque(0);
                setQuantidadeDoEstoque(0)

            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }




    }






    async function finalizarRequerimento() {


        if ((!ordemServico.itens_pre_requerimento ||
            ordemServico.itens_pre_requerimento.length < 1)) {
            alert("Adicione ao menos 1 Insumo na lista de Requerimento");
            return;
        }

        const confirmacao = window.confirm("Prosseguir com finalização do Requerimento de Itens?");


        if (confirmacao) {
            try {

                console.log("cadastrar chamado");

                const headers = {
                    'Authorization': 'Bearer ' + Cookies.get("token")
                }

                const id_usuario_logado = parseInt(Cookies.get("id_usuario"));


                let url = "";

                if (flag === 2) {
                    url = "/v1/protected/ordemservico/finalizarrequerimentoanaliseprevia/" + ordemServico.id_ordem_servico + "/" + id_usuario_logado;
                }
                else {

                    url = "/v1/protected/ordemservico/finalizarrequerimento/" + ordemServico.id_ordem_servico + "/" + id_usuario_logado;
                }
                const response = await api.put(url,
                    { headers: headers });

                const cadastro_salvo = response.data;
                if (cadastro_salvo) {
                    alert("Requerimento de Itens Finalizado!");
                    window.location.reload();


                } else {
                    alert("Erro de Conexão, tente novamente mais tarde");
                }


            } catch (_err) {
                console.log("erro ao cadastrar: " + _err);
                alert("Erro de Conexão, tente novamente mais tarde");

            }

        }


    }


    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }



    const handleCellClick = (param, event) => {
        event.stopPropagation();
    };

    const handleRowClick = (param, event) => {
        event.stopPropagation();
    };









    async function handleClickRemocao(event, cellValues) {



        try {

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const id_usuario_logado = parseInt(Cookies.get("id_usuario"));


            const response = await api.delete("/v1/protected/ordemservico/editarrequerimento/" + ordemServico.id_ordem_servico + "/" + id_usuario_logado + "/removeritem/" + cellValues.row.id_item_requerimento,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Removido!");
                recarregarItens();


            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }


    };


    const [observacoesEditingValue, setObservacoesEditingValue] = useState('');

    const handleInputObservacoesEditingChange = (event) => {
        const value = event.target.value;
        console.log(value); // imprime tudo que foi digitado, inclusive espaços
        setObservacoesEditingValue(value);
    };



    const handleAtualizarObservacoesAlmoxarifado = async (cellValues) => {

        const id_item_requerimento = cellValues.row.id_item_requerimento;
        const cadastro = {
            observacoes_almoxarifado: observacoesEditingValue,

        };
        const headers = {
            'Authorization': 'Bearer ' + Cookies.get("token")
        }
        const response = await api.put(`/v1/protected/ordemservico/editarrequerimento/atualizaritem/observacoesalmoxarifado/${id_item_requerimento}`, cadastro,
            { headers: headers });

        const cadastro_salvo = response.data;
        if (cadastro_salvo) {

            recarregarItens();

        } else {
            alert("Erro de Conexão, tente novamente mais tarde");

        }


    };

    const [openAtualizando, setOpenAtualizando] = useState(false);



    const [quantidadeEditingValue, setQuantidadeEditingValue] = useState(0);
    const handleInputQuantidadeChange = (event) => {
        setQuantidadeEditingValue(event.target.value);
    };


    const handleAtualizarQuantidade = async (cellValues, quantidadeReservada) => {
        const quantidade = cellValues.row.quantidade; // quantidade pedida

        // Validação: não permitir quantidade_reservada maior que quantidade
        if (quantidadeReservada > quantidade) {
            alert(`A quantidade reservada não pode ser maior que a quantidade pedida (${quantidade})`);
            return; // sai da função sem chamar a API
        }

        setOpenAtualizando(true);

        const id = cellValues.row.id_item_requerimento;
        const cadastro = {
            quantidade_reservada: quantidadeReservada,
        };

        const headers = {
            'Authorization': 'Bearer ' + Cookies.get("token")
        };

        try {
            const response = await api.put(
                '/v1/protected/ordemservico/' + ordemServico.id_ordem_servico + '/editarrequerimento/atualizaritem/quantidadereservada/' + id,
                cadastro,
                { headers: headers }
            );

            const cadastro_salvo = response.data;
            if (!cadastro_salvo) {
                alert("Erro de Conexão, tente novamente mais tarde");
            } else {
                recarregarItens();
            }
        } catch (error) {
            alert(error.response?.data || "Erro ao atualizar quantidade");
        } finally {
            setOpenAtualizando(false);
        }
    };


    const [insumoKey, setInsumoKey] = useState(0);


    const [informacoesEstoqueInsumo, setInformacoesEstoqueInsumo] = useState(null);

    async function consultarEstoqueItem(id_insumo) {
        console.log("funcao chamada!");
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            };

            const response = await api.get(
                `v1/protected/almoxarifado/estoque/listarporinsumosrapidoporid/${id_insumo}`,
                { headers }
            );

            console.log(JSON.stringify(response.data));
            let texto = returnDescricaoInsumo(response.data[0]);
            setInformacoesEstoqueInsumo(texto);
            // setInsumoKey(prev => prev + 1);


        } catch (err) {
            console.log("Erro ao listar informações: " + err);
        }
    }

    const columnsDataGrid = [
        {
            field: 'acoes',
            headerName: 'Ações',
            headerClassName: 'cabecalho_marrom_claro',
            sortable: false,
            width: 50,
            renderCell: (cellValues) => (
                <IconButton
                    color="error" // vermelho
                    onClick={(event) => handleClickRemocao(event, cellValues)}
                >
                    <DeleteIcon />
                </IconButton>
            ),
        },
        {
            headerName: 'Item',
            field: 'id_item_na_lista',
            id: 2,
            width: 50,
            headerClassName: 'cabecalho_azul',
        },

        {
            headerName: 'Insumo',
            field: 'insumo',
            id: 3,
            width: 350,
            headerClassName: 'cabecalho_azul',
            renderCell: (params) => {
                const insumo = params.row.insumo;

                // 🔍 Detecta automaticamente o ID correto (dependendo do seu backend)
                const idInsumo = insumo?.id_insumo > 0
                    ? insumo.id_insumo
                    : insumo?.insumo?.id_insumo > 0
                        ? insumo.insumo.id_insumo
                        : null;

                let descricao = returnDescricaoInsumoSimplificada(insumo);
                descricao = descricao.replace(/<br\s*\/?>/gi, '\n');

                return (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '100%',
                        }}
                    >
                        {/* Texto */}
                        <div
                            style={{
                                whiteSpace: 'pre-wrap',
                                overflowWrap: 'break-word',
                                wordBreak: 'break-word',
                                flex: 1,
                                marginRight: '8px'
                            }}
                        >
                            {descricao}
                        </div>

                        {/* 🔹 Botão com Tooltip */}
                        {idInsumo ? (
                            <Tooltip
                                title={
                                    <div style={{ backgroundColor: 'white', color: 'black', padding: 10, fontSize: 16 }}>

                                        <div dangerouslySetInnerHTML={{ __html: informacoesEstoqueInsumo ? informacoesEstoqueInsumo : "Sem informações de Estoque" }} />

                                    </div>

                                }
                                placement="top"
                                arrow
                                style={{ backgroundColor: darkMode ? '#333' : 'white' }}
                                sx={{ backgroundColor: darkMode ? '#333' : 'white' }}
                            >
                                <IconButton
                                    sx={{ color: darkMode ? 'white' : 'inherit' }}
                                    onClick={() => consultarEstoqueItem(idInsumo)}
                                    size="small"
                                >
                                    <InventoryIcon />
                                </IconButton>
                            </Tooltip>
                        ) : null}
                    </div>
                );
            },
        },
        {
            headerName: 'Qtd Pedida',
            field: 'quantidade',
            id: 6,
            width: 100,
            headerClassName: 'cabecalho_azul',
        },
        /*
        {
            headerName: 'Qtd Reservada',
            field: 'quantidade_reservada',
            width: 100,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                const quantidade = cellValues.row.quantidade;
                const quantidadeReservada = cellValues.row.quantidade_reservada;

                const [inputValue, setInputValue] = React.useState(quantidadeReservada);

                return (
                    <TextField
                        value={inputValue}
                        onFocus={() => setInputValue(quantidadeReservada)}
                        onChange={(event) => {
                            let valor = parseInt(event.target.value, 10) || 0;
                            if (valor <= quantidade) {
                                setInputValue(valor);
                            } else {
                                setInputValue(quantidade); // força o valor máximo permitido
                            }
                        }}
                        onBlur={() => {
                            // aqui enviamos exatamente o valor atual do input
                            handleAtualizarQuantidade(cellValues, inputValue);
                        }}
                        variant="outlined"
                    />
                );
            },
        },*/
        {
            headerName: 'Qtd Reservada',
            field: 'quantidade_reservada',
            width: 160,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                const quantidadeReservada = cellValues.row.quantidade_reservada;

                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span>{quantidadeReservada}</span>

                        <Button
                            variant="outlined"
                            size="small"
                            onClick={() => handleGerenciarReserva(cellValues.row)}
                        >
                            <EditIcon fontSize="small" />
                        </Button>
                    </div>
                );
            },
        },
        {
            headerName: 'Qtd a Comprar',
            field: 'quantidade_a_comprar',
            id: 6,
            width: 100,
            headerClassName: 'cabecalho_azul',
        },
        {
            headerName: 'Observações',
            field: 'observacoes',
            id: 7,
            width: 150, // 🔹 Metade do tamanho original (600 → 300)
            headerClassName: 'cabecalho_azul',
            renderCell: (params) => (
                <div
                    style={{
                        whiteSpace: 'pre-wrap', // 🔹 Permite quebra automática
                        overflowWrap: 'break-word',
                        wordBreak: 'break-word',
                    }}
                >
                    {params.value}
                </div>
            ),
        },
        {
            headerName: 'Observações Almoxarife',
            field: 'observacoes_almoxarifado',
            width: 400,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                const observacoes_almoxarifado = cellValues.row.observacoes_almoxarifado || 'NAN';

                return (
                    <TextField
                        defaultValue={observacoes_almoxarifado}
                        onBlur={() => handleAtualizarObservacoesAlmoxarifado(cellValues)}
                        onFocus={() => setObservacoesEditingValue(observacoes_almoxarifado)}
                        onChange={(event) => {
                            console.log("Caractere digitado:", event.nativeEvent.data);
                            console.log("Valor atual:", event.target.value);
                            handleInputObservacoesEditingChange(event);
                        }}
                        onKeyDown={(e) => {
                            if (e.code === "Space") {
                                e.stopPropagation();
                            }
                        }}
                        variant="outlined"
                        multiline
                        minRows={3}
                        maxRows={3}
                        sx={{
                            maxHeight: 70,
                            overflowY: 'auto' // ✅ habilita scroll vertical
                        }}
                    />
                );
            },
        }

    ];


    const [textoBusca, setTextoBusca] = useState("");

    useEffect(() => {

        if (textoBusca.length < 3) {
            return; // não busca com menos de 3 chars
        }

        const delayDebounce = setTimeout(() => {
            buscarInsumo(textoBusca);
        }, 500);

        return () => clearTimeout(delayDebounce);

    }, [textoBusca]);

    async function buscarInsumo(descricao) {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            };

            const response = await api.get(
                `v1/protected/almoxarifado/estoque/listarporinsumosrapidopordescricao?descricao_busca=${descricao}`,
                { headers }
            );

            setInsumos(response.data);

        } catch (err) {
            console.log("Erro ao listar informações: " + err);
        }
    }


    return (
        <MuiThemeProvider theme={themeV5}>
            <CoreThemeProvider theme={themeV4}>
                <div style={{ backgroundColor: themeV5.palette.background.default, color: themeV5.palette.text.primary, minHeight: '100%', padding: '10px' }}>
                    <div>





                        {ordemServico.finalizar_requerimento_itens === 1 &&
                            ordemServico.id_ordem_compra > 0 &&

                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="flex-start"
                                item xs={6}
                            >

                                <span style={{ fontSize: 16, color: darkMode ? 'white' : 'black', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <Tooltip title="Abrir Ordem de Compra">
                                        <IconButton
                                            color="primary"
                                            size="small"
                                            onClick={() => window.open(`/gestao/administracao/ordensdecompras/editar/${ordemServico.id_ordem_compra}`, '_blank')}
                                        >
                                            <SettingsIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    Ordem de Compra nº {ordemServico.id_ordem_compra}
                                </span>

                            </Grid>
                        }

                        {ordemServico.finalizar_requerimento_itens === 0 &&
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-end"
                                alignItems="flex-end"
                                item xs={6}
                            >


                                <Button
                                    variant='outlined'
                                    style={{ paddingTop: 2 }}
                                    color="primary"
                                    onClick={(ev) => finalizarRequerimento()}
                                    endIcon={<CheckIcon />}
                                >
                                    Finalizar Requerimento
                                </Button>
                            </Grid>
                        }


                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            align="center"
                            item xs={12}
                            style={{ padding: 20 }}
                        >
                            <Grid
                                container
                                direction="column"
                                justifyContent="center"
                                align="center"
                                item xs={8}
                            >

                                <Autocomplete
                                    id="select-insumo"
                                    options={insumos}
                                    disableCloseOnSelect
                                    getOptionLabel={(insumo) =>
                                        returnDescricaoInsumo(insumo).replace(/<br \/>/g, '\n')
                                    }
                                    value={insumoSelecionado}

                                    onChange={(e, v) => handleSetInsumoSelecionado(v)}

                                    // 🔥 captura O TEXTO DIGITADO
                                    onInputChange={(event, newInputValue) => {
                                        setTextoBusca(newInputValue);
                                    }}

                                    filterOptions={(options, { inputValue }) => {
                                        const inputKeywords = inputValue.toLowerCase().split(" ");
                                        return options.filter((insumo) => {
                                            const insumoText = returnDescricaoInsumo(insumo).toLowerCase();
                                            return inputKeywords.some((keyword) => insumoText.includes(keyword));
                                        });
                                    }}

                                    renderInput={(params) => (
                                        <TextField {...params} label="Insumo" multiline minRows={2} />
                                    )}

                                    renderOption={(option) => (
                                        <div dangerouslySetInnerHTML={{ __html: returnDescricaoInsumo(option) }} />
                                    )}
                                />
                            </Grid>


                            <Grid
                                container
                                item xs={2}
                                justifyContent="center"
                                alignItems="center"
                            >
                                <TextField
                                    variant="standard"
                                    name="quantidade"
                                    label="Quantidade"
                                    id="quantidade"
                                    value={quantidade}
                                    onChange={(e) => setQuantidade(e.target.value)}
                                    fullWidth
                                />
                            </Grid>


                            {temEstoque && (
                                <Grid
                                    container
                                    item
                                    xs={6} // Aumenta o espaço para comportar o TextField e o Typography
                                    justifyContent="flex-start"
                                    alignItems="center"
                                    spacing={1}
                                >
                                    <Grid item>
                                        <Typography variant="body2" color="textSecondary">
                                            {quantidadeNoEstoque} disponíveis
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography variant="body2" color="textSecondary">
                                            Máx: {Math.min(quantidade, quantidadeNoEstoque)}
                                        </Typography>
                                    </Grid>
                                    <Grid
                                        container
                                        item xs={4}
                                        justifyContent="center"
                                        alignItems="center"
                                        style={{ marginRight: 2 }}
                                    >
                                        <TextField
                                            variant="standard"
                                            name="quantidadeDoEstoque"
                                            label="Quantidade do Estoque"
                                            id="quantidadeDoEstoque"
                                            value={quantidadeDoEstoque}
                                            inputProps={{
                                                type: "number",
                                                min: 0,
                                                max: Math.min(quantidade, quantidadeNoEstoque)
                                            }} onChange={(e) => handleSetQuantidadeDoEstoque(e.target.value)}
                                            fullWidth
                                        />
                                    </Grid>
                                </Grid>
                            )}



                            <Grid
                                container
                                item xs={12}
                                justifyContent="center"
                                alignItems="center"
                                style={{ paddingTop: 10 }}
                            >
                                <TextField
                                    variant="standard"
                                    name="observacoesItem"
                                    label="Observações"
                                    id="observacoesItem"
                                    value={observacoesItem}
                                    onChange={(e) => setObservacoesItem(e.target.value)}
                                    fullWidth
                                    multiline
                                    minRows={2}
                                />
                            </Grid>


                            {
                                regra.includes("ADMIN_INSUMOS_NOVO_INSUMO")
                                &&
                                (<Grid
                                    container
                                    item xs={12}
                                    justifyContent="center"
                                    alignItems="center"
                                    style={{ paddingTop: 10 }}
                                >
                                    <TextField
                                        variant="standard"
                                        name="descricaoNovoInsumo"
                                        label="Descrição para Novo Insumo"
                                        id="descricaoNovoInsumo"
                                        value={descricaoNovoInsumo}
                                        onChange={(e) => setDescricaoNovoInsumo(e.target.value)}
                                        fullWidth
                                        multiline
                                        minRows={2}
                                    />
                                </Grid>)

                            }





                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                item xs={2}
                            >
                                <Button style={{ marginTop: 5 }}
                                    variant="contained"
                                    color="primary"
                                    onClick={(ev) => adicionarItem()}
                                > Adicionar Item  </Button>
                            </Grid>





                        </Grid>




                        <Grid
                            style={{ paddingTop: 5 }}
                            container
                            direction="row"
                            item xs={12}
                            alignItems="center"
                            justifyContent="center"
                        >
                            {
                                ordemServico.itens_pre_requerimento &&
                                <>
                                    <DataGrid
                                        pagination
                                        checkboxSelection
                                        rows={ordemServico.itens_pre_requerimento}
                                        getRowId={(row) => row.id_item_requerimento}
                                        columns={columnsDataGrid}
                                        disableColumnResize={false}
                                        rowHeight={80}
                                        onCellClick={handleCellClick}
                                        onRowClick={handleRowClick}
                                        components={{
                                            Toolbar: CustomToolbar,
                                        }}
                                    />

                                </>
                            }



                        </Grid>


                    </div>




                    {mostrarDialog && (
                        <div
                            style={{
                                position: "fixed",
                                bottom: "20px",
                                right: "20px",
                                backgroundColor: darkMode ? "#1e1e1e" : "#fff",
                                color: darkMode ? "#fff" : "#000",
                                borderRadius: "8px",
                                padding: "16px 20px",
                                width: "320px",
                                textAlign: "center",
                                boxShadow: "0 0 10px rgba(0,0,0,0.25)",
                                zIndex: 9999,
                                pointerEvents: "auto", // permite clique no botão
                            }}
                        >
                            <h4 style={{ marginBottom: "8px", color: darkMode ? "#ef5350" : "#d32f2f" }}>Atenção ⚠️</h4>
                            <p style={{ fontSize: "14px", marginBottom: "10px", color: darkMode ? "#ccc" : "#000" }}>
                                {(!ordemServico.itens_pre_requerimento ||
                                    ordemServico.itens_pre_requerimento.length < 1) &&
                                    "Você deve adicionar ao mínimo 1 item na lista de requerimento."}

                                {ordemServico.itens_pre_requerimento &&
                                    ordemServico.itens_pre_requerimento.length >= 1 &&
                                    ordemServico.finalizar_requerimento_itens === 0 &&
                                    'Finalize sua solicitação clicando no botão "Finalizar".'}
                            </p>

                            <button
                                style={{
                                    backgroundColor: "#1976d2",
                                    color: "#fff",
                                    border: "none",
                                    padding: "8px 16px",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    fontSize: "13px",
                                    fontWeight: "bold",
                                }}
                                onClick={() => setMostrarDialog(false)}
                            >
                                Entendido
                            </button>
                        </div>
                    )}



                    {!loading && informaDialog && ordemServico &&
                        ordemServico.solicitacao.id_solicitacao === 7 &&
                        ordemServico.finalizar_requerimento_itens === 0 &&
                        (
                            <div
                                style={{
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    width: "100vw",
                                    height: "100vh",
                                    backgroundColor: "rgba(0,0,0,0.6)",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    zIndex: 9999,
                                }}
                            >
                                <div
                                    style={{
                                        backgroundColor: darkMode ? "#1e1e1e" : "#fff",
                                        color: darkMode ? "#fff" : "#000",
                                        borderRadius: "8px",
                                        padding: "24px",
                                        width: "400px",
                                        textAlign: "center",
                                        boxShadow: "0 0 15px rgba(0,0,0,0.3)",
                                    }}
                                >
                                    <h3 style={{ marginBottom: "12px", color: darkMode ? "#90caf9" : "#1976d2" }}>Atenção 📘</h3>
                                    <p
                                        style={{
                                            marginBottom: "16px",
                                            fontSize: "15px",
                                            color: darkMode ? "#ccc" : "#333",
                                            lineHeight: "1.5",
                                        }}
                                    >
                                        Para finalizar sua solicitação, adicione itens na lista de
                                        requerimento na aba{" "}
                                        <strong>"Requerimento de Insumos"</strong>, e quando finalizar,
                                        clique no botão <strong>"Finalizar"</strong>.
                                    </p>
                                    <button
                                        style={{
                                            backgroundColor: "#1976d2",
                                            color: "#fff",
                                            border: "none",
                                            padding: "10px 20px",
                                            borderRadius: "6px",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                            transition: "background-color 0.2s",
                                        }}
                                        onMouseOver={(e) =>
                                            (e.currentTarget.style.backgroundColor = "#1565c0")
                                        }
                                        onMouseOut={(e) =>
                                            (e.currentTarget.style.backgroundColor = "#1976d2")
                                        }
                                        onClick={() => setInformaDialog(false)}
                                    >
                                        Entendido
                                    </button>
                                </div>
                            </div>
                        )}




                    <Snackbar
                        open={openAtualizando}
                        autoHideDuration={1500}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    >
                        <MuiAlert elevation={6} variant="filled"  >
                            Atualizando...
                        </MuiAlert>
                    </Snackbar>

                    <Dialog open={openGerenciarReserva} onClose={handleCloseGerenciarReserva} PaperProps={{ style: { maxWidth: '600px', minWidth: '600px', minHeight: '600px' } }}>
                        <DialogTitle>Gerenciar Reserva</DialogTitle>
                        <DialogContent>

                            <GerenciarReserva idOrdemServico={ordemServico.id_ordem_servico} reserva={reservaGerenciada} onClose={handleCloseGerenciarReserva} />

                        </DialogContent>
                    </Dialog>



                </div>
            </CoreThemeProvider>
        </MuiThemeProvider>
    );
}


